module.exports = __webpack_public_path__ + "img/success-modal.4326dece.svg";